/* GENERATED by scripts/gen-data.mjs — film scene "f-cost" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_COST: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "cl",
      "x": 14,
      "y": 126,
      "w": 118,
      "h": 56,
      "lKey": "films:f-cost.items.cl.l"
    },
    {
      "k": "note",
      "id": "h1",
      "x": 158,
      "y": 56,
      "lKey": "films:f-cost.items.h1.l"
    },
    {
      "k": "bar",
      "id": "b1",
      "x": 158,
      "y": 84,
      "w": 212,
      "h": 14,
      "v": 1,
      "lKey": "films:f-cost.items.b1.l"
    },
    {
      "k": "bar",
      "id": "b2",
      "x": 158,
      "y": 130,
      "w": 212,
      "h": 14,
      "v": 0.55,
      "lKey": "films:f-cost.items.b2.l"
    },
    {
      "k": "bar",
      "id": "b3",
      "x": 158,
      "y": 176,
      "w": 212,
      "h": 14,
      "v": 0.34,
      "lKey": "films:f-cost.items.b3.l"
    },
    {
      "k": "box",
      "id": "out",
      "x": 452,
      "y": 126,
      "w": 174,
      "h": 56,
      "lKey": "films:f-cost.items.out.l"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "cl",
      "to": "out",
      "dash": true
    },
    {
      "k": "note",
      "id": "n1",
      "x": 158,
      "y": 214,
      "lKey": "films:f-cost.items.n1.l"
    }
  ],
  "steps": [
    {
      "on": [
        "cl",
        "h1",
        "b1",
        "w1",
        "out"
      ],
      "hot": [
        "b1",
        "cl"
      ],
      "capKey": "films:f-cost.steps.0.cap"
    },
    {
      "on": [
        "cl",
        "h1",
        "b1",
        "b2",
        "w1",
        "out"
      ],
      "hot": [
        "b2"
      ],
      "capKey": "films:f-cost.steps.1.cap"
    },
    {
      "on": [
        "cl",
        "h1",
        "b1",
        "b2",
        "b3",
        "w1",
        "out"
      ],
      "hot": [
        "b3"
      ],
      "capKey": "films:f-cost.steps.2.cap"
    },
    {
      "on": [
        "cl",
        "h1",
        "b1",
        "b2",
        "b3",
        "w1",
        "out",
        "n1"
      ],
      "hot": [
        "n1"
      ],
      "capKey": "films:f-cost.steps.3.cap"
    }
  ]
};
